import React, { useEffect, useState } from "react";
import Header from "../common/layout/header";
import Footer from "../common/layout/footer";
import Sidebar from "../common/sidebar";
import { http } from "../helper";
import { BaseUrl } from "../common/config";
import Select from "react-select";
import { useTranslation } from "react-i18next";

const AddChefs = () => {
  const { t } = useTranslation();
  const [groupName, setGroupName] = useState("");
  const [priceBand, setPriceBand] = useState([]);
  const [priceBands, setPriceBands] = useState([]);
  const [errorMsg, setErrorMsg] = useState({});
  const [accounts, setAccounts] = useState([]);
  const [filteredAccounts, setFilteredAccounts] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState([]);
  const [primaryAccount, setPrimaryAccount] = useState(null);
  const [status, setStatus] = useState("active");
  const [alertPopup, setAlertPopup] = useState(false);
  const [alertMessage, setAlertMessage] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [existingChefs, setExistingChefs] = useState([]);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [restrictedAccounts, setRestrictedAccounts] = useState([]);
  const [restrictedLoaded, setRestrictedLoaded] = useState(false);
  const [hoAccountlist, setHoAccountcodelist] = useState([]);
  const [hoAccountLoaded, setHoAccountLoaded] = useState(false);
  const [chefAccountList, setChefAccountList] = useState([]);
  const [chefAccountLoaded, setChefAccountLoaded] = useState(false);
  // Redirect unauthenticated or unauthorized users
  if (!sessionStorage.getItem("isLoggedIn")) {
    window.location.href = "/";
  }
  if (
    JSON.parse(sessionStorage.getItem("authData")) !== "" &&
    !JSON.parse(
      sessionStorage.getItem("authData"),
    ).adminRole.permissions.includes("manage_chefs")
  ) {
    window.location.href = "/unauthorized";
  }

  useEffect(() => {
    http
      .get(BaseUrl + "admin/accountcodelist") // get restricted accounts
      .then((res) => {
        const ids = res.data?.data?.map((acc) => acc.accountCode);
        setRestrictedAccounts(ids || []);
      })
      .catch((err) => {
        console.error("Failed to fetch restricted accounts", err);
        setRestrictedAccounts([]);
      })
      .finally(() => {
        setRestrictedLoaded(true);
      });
  }, []);
  // get ho accounts
  useEffect(() => {
    http
      .get(BaseUrl + "admin/hoaccountlist")
      .then((res) => {
        const Hoids = res.data?.data?.map((acc) => acc.accountCode);
        setHoAccountcodelist(Hoids || []);
      })
      .catch((err) => {
        console.error("Failed to fetch Ho accounts", err);
        setHoAccountcodelist([]);
      })
      .finally(() => {
        setHoAccountLoaded(true);
      });
  }, []);

  useEffect(() => {
    http
      .get(BaseUrl + "admin/chefaccountcodelist")
      .then((res) => {
        const chefIds = res.data?.data?.map((acc) => acc.accountCode);
        setChefAccountList(chefIds || []);
      })
      .catch((err) => {
        console.error("Failed to fetch Chef restricted accounts", err);
        setChefAccountList([]);
      })
      .finally(() => {
        setChefAccountLoaded(true);
      });
  }, []);
  // Helper to get all already used accounts primary + sub for selected price bands
  const getUsedAccountIds = () => {
    const selectedBands = priceBand.map((pb) => pb.value);
    return existingChefs
      .filter((chef) =>
        chef.priceBand?.some((band) => selectedBands.includes(band)),
      )
      .flatMap((chef) => [
        ...(chef.accounts || []).map((acc) => acc._id || acc),
        chef.primaryAccount?._id || chef.primaryAccount,
      ])
      .filter(Boolean);
  };
  // Fetch unique price bands
  useEffect(() => {
    if (!restrictedLoaded || !hoAccountLoaded || !chefAccountLoaded) return;
    const fetchPriceBands = async () => {
      try {
        const response = await http.get(`${BaseUrl}admin/account`);
        const accountsData = response.data.data;
        let activeAccounts = accountsData.filter((acc) => {
          return (
            acc.accountStatus === "active" && acc.accountWebSiteAccess === "Yes"
          );
        });
        setAccounts(activeAccounts);
        const uniqueBands = [
          ...new Set(
            activeAccounts.map((acc) => acc.accountPriceListId).filter(Boolean),
          ),
        ];
        setPriceBands(uniqueBands);
      } catch (error) {
        console.error("Error fetching price bands:", error);
      }
    };

    const fetchChefs = async () => {
      try {
        const response = await http.get(`${BaseUrl}admin/getchefs`);
        setExistingChefs(response.data.data || []);
      } catch (error) {
        console.error("Error fetching existing chefs", error);
      }
    };
    fetchPriceBands();
    fetchChefs();
  }, [restrictedLoaded, hoAccountLoaded, chefAccountLoaded]);
  // if price band or account name change
  useEffect(() => {
    if (priceBand.length > 0) {
      const selectedBands = priceBand.map((pb) => pb.value);
      const filtered = accounts.filter((acc) =>
        selectedBands.includes(acc.accountPriceListId),
      );
      setFilteredAccounts(filtered);
      setSelectedAccount([]); // Reset selection on price change
      setPrimaryAccount(null); // Reset primary account selection on price change
      setFormSubmitted(false);
    } else {
      setFilteredAccounts([]);
      setSelectedAccount([]);
      setPrimaryAccount(null);
    }
  }, [priceBand, accounts]);

  const cancelbtn = (e) => {
    e.preventDefault();
    window.location.href = "/development-chef";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormSubmitted(true);
    let errors = {};
    if (!groupName.trim()) {
      errors.groupName = t("field_required_txt");
    }
    const duplicate = existingChefs.find(
      (chef) => chef.groupName.toLowerCase() === groupName.trim().toLowerCase(),
    );
    if (duplicate) {
      errors.groupName = t("group_name_already_exists_txt");
    }
    if (!priceBand || priceBand.length === 0) {
      errors.priceBand = t("field_required_txt");
    }
    if (!primaryAccount) {
      errors.primaryAccount = t("field_required_txt");
    }
    setErrorMsg(errors);
    if (Object.keys(errors).length === 0) {
      // Prepare data to send
      const payload = {
        groupName,
        priceBand: priceBand.map((pb) => pb.value),
        primaryAccount: primaryAccount._id,
        accounts: selectedAccount.map((acc) => acc.value),
        groupStatus: status,
      };
      try {
        const response = await http.post(`${BaseUrl}admin/addchef`, payload);
        setIsLoading(false);
        setAlertMessage(t("development_chef_added_successfully_txt"));
        setAlertPopup(true);
      } catch (error) {
        setIsLoading(false);
        const msg =
          error?.response?.data?.message ||
          t("error_adding_development_chef_txt");
        setAlertMessage(msg);
        setAlertPopup(true);
        console.error("Error:", error);
      }
    }
  };

  return (
    <section className="dashboard-block">
      {alertPopup && (
        <div
          className="custom-alert-pop common_alert_popup"
          style={{ display: "block" }}
        >
          <div className="custom-alert-container">
            <div className="custom-alert-wrap">
              <div className="custom-alert-header">
                <h4>{t("alert_txt")}</h4>
              </div>
              <div className="custom-alert-body">
                <p>{alertMessage}</p>
                <div className="alert-buttons">
                  <a
                    onClick={() => (window.location.href = "/development-chef")}
                    className="popup-alert-btn button"
                  >
                    {t("ok_txt")}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <Sidebar />
      <div className="dash-left">
        <Header />
        <section className="cart-block">
          <div className="container">
            <h1 className="checkout-title">{t("add_development_chef_txt")}</h1>
            <div className="right-table-outer-wrap">
              <form
                method="post"
                className="addform form-container-xs"
                onSubmit={handleSubmit}
              >
                <div className="input-field col-1">
                  <label>{t("group_name_txt")}</label>
                  <input
                    type="text"
                    value={groupName}
                    onChange={(e) => {
                      setGroupName(e.target.value);
                      setErrorMsg((prev) => ({ ...prev, groupName: "" }));
                    }}
                    className="form-control"
                    placeholder={t("enter_group_name_txt")}
                  />
                  {formSubmitted && errorMsg.groupName && (
                    <div className="error-msg">{errorMsg.groupName}</div>
                  )}
                </div>
                <div className="input-field col-1">
                  <label>{t("price_band_txt")}</label>
                  <Select
                    isMulti
                    closeMenuOnSelect={false}
                    value={priceBand}
                    onChange={(selected) => {
                      setPriceBand(selected);
                      setErrorMsg((prev) => ({ ...prev, priceBand: "" }));
                    }}
                    options={priceBands.map((band) => ({
                      value: band,
                      label: band,
                    }))}
                    className="form-control"
                    placeholder={t("select_price_bands_txt")}
                    styles={{
                      menu: (base) => ({
                        ...base,
                        position: "relative",
                        zIndex: 1,
                      }),
                    }}
                  />
                  {formSubmitted && errorMsg.priceBand && (
                    <div className="error-msg">{errorMsg.priceBand}</div>
                  )}
                </div>
                {priceBand.length > 0 && (
                  <div className="input-field col-1">
                    <label>{t("select_primary_account_txt")}</label>
                    <select
                      value={primaryAccount?._id || ""}
                      onChange={(e) => {
                        const selected = filteredAccounts.find(
                          (a) => a._id === e.target.value,
                        );
                        if (selected) {
                          setPrimaryAccount(selected);
                          setErrorMsg((prev) => ({
                            ...prev,
                            primaryAccount: "",
                          }));
                          setFormSubmitted(false);
                          // Remove the new primary account from selectedAccount list (if already selected)
                          setSelectedAccount((prev) =>
                            prev.filter((acc) => acc.value !== selected._id),
                          );
                        } else {
                          setPrimaryAccount(null);
                          setSelectedAccount([]);
                        }
                      }}
                      className="form-control"
                    >
                      <option value="">
                        {t("select_primary_account_option_txt")}
                      </option>
                      {filteredAccounts
                        .filter(
                          (account) =>
                            (!getUsedAccountIds().includes(account._id) ||
                              account._id === primaryAccount?._id) &&
                            account.accountWebSiteAccess === "Yes" &&
                            !hoAccountlist.includes(account.accountCode) &&
                            !chefAccountList.includes(account.accountCode),
                        )
                        .map((account) => (
                          <option key={account._id} value={account._id}>
                            {account.accountCode} - {account.accountName}
                          </option>
                        ))}
                    </select>
                    {formSubmitted && errorMsg.primaryAccount && (
                      <div className="error-msg">{errorMsg.primaryAccount}</div>
                    )}
                  </div>
                )}
                {primaryAccount && (
                  <div className="input-field col-1">
                    <label>{t("select_sub_account_names_txt")}</label>
                    <Select
                      isMulti
                      closeMenuOnSelect={false}
                      options={filteredAccounts
                        .filter(
                          (acc) =>
                            acc._id !== primaryAccount._id &&
                            !chefAccountList.includes(acc.accountCode) &&
                            (!getUsedAccountIds().includes(acc._id) ||
                              selectedAccount.some(
                                (sa) => sa.value === acc._id,
                              )),
                        )
                        .map((acc) => ({
                          value: acc._id,
                          label: `${acc.accountCode} - ${acc.accountName}`,
                          data: acc,
                        }))}
                      value={selectedAccount}
                      onChange={(selected) => {
                        setSelectedAccount(selected);
                        setErrorMsg((prev) => ({
                          ...prev,
                          selectedAccount: "",
                        }));
                      }}
                      className="form-control"
                      styles={{
                        menu: (base) => ({
                          ...base,
                          position: "relative",
                          zIndex: 1,
                        }),
                      }}
                    />
                    {formSubmitted && errorMsg.selectedAccount && (
                      <div className="error-msg">
                        {errorMsg.selectedAccount}
                      </div>
                    )}
                  </div>
                )}
                {/* Status Checkbox */}
                <div className="input-field col-1">
                  <label className="full-width">{t("status_txt")}</label>
                  <select
                    className="col-4"
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                  >
                    <option value="active">{t("active_txt")}</option>
                    <option value="inactive">{t("inactive_txt")}</option>
                  </select>
                </div>
                <button title={t("submit_txt")} type="submit">{t("submit_txt")}</button>&nbsp;&nbsp;
                <button title={t("cancel_txt")} onClick={cancelbtn}>{t("cancel_txt")}</button>
              </form>
            </div>
          </div>
        </section>
        <Footer />
      </div>
    </section>
  );
};

export default AddChefs;
